import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './QuickBankAccount.css';

const SavingsAccountReport = () => {
    const [accounts, setAccounts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    
    const navigate = useNavigate();
    const superAdminId = localStorage.getItem("adminuserId") || "14";
    const BASE_URL = "https://payyug.in/";

    const fetchReport = async (page) => {
        setLoading(true);
        try {
            const response = await axios.get(
                `https://payyug.in/api/dashboard-saving/report?superAdminId=${superAdminId}&page=${page}`
            );
            
            if (response.data.success) {
                setAccounts(response.data.data);
                setTotalPages(response.data.totalPages);
                setCurrentPage(response.data.currentPage);
            }
        } catch (err) {
            setError(err.message || "Failed to load data");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReport(currentPage);
    }, [currentPage]);

    if (loading && accounts.length === 0) return <div className="loader">Loading Reports...</div>;

    return (
        <div className="Quick-bank-account-report-container">
            
            <div className="report-title"> 
               <h2> Saving Account Applications</h2>
            </div>
            <div className="table-card">
                <table className="Quick-bank-account-table">
                    <thead>
                        <tr>
                            <th>Profile</th>
                            <th>Customer Name</th>
                            <th>Mobile</th>
                            <th>Aadhaar</th>
                            <th>PAN</th>
                            <th>Min. Balance</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {accounts.map((acc) => (
                            <tr key={acc.id}>
                                <td>
                                    <img 
                                        src={acc.profilePicture ? `${BASE_URL}${acc.profilePicture}` : '/default-avatar.png'} 
                                        alt="Profile" 
                                        className="table-profile-img"
                                    />
                                </td>
                                <td>
                                    <div className="name-bold">{acc.firstName} {acc.lastName}</div>
                                    
                                </td>
                                <td>{acc.mobile}</td>
                                <td>
                                    <div >{acc.aadhaarNumber}</div>
                                </td>
                                <td>
                                   <div >{acc.panNumber}</div>
                                </td>
                                <td>₹{acc.minimumBalance}</td>
                                <td>
                                    <span className={`status-pill ${acc.status?.toLowerCase() || 'pending'}`}>
                                        {acc.status || 'Pending'}
                                    </span>
                                </td>
                                <td>{new Date(acc.createdAt).toLocaleDateString()}</td>
                                <td>
                                    <button 
                                        className="view-btn" 
                                        onClick={() => navigate('/viewbankaccountreport', { state: { account: acc } })}
                                    >
                                        View
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="pagination">
                <button 
                    disabled={currentPage === 1} 
                    onClick={() => setCurrentPage(prev => prev - 1)}
                >
                    Prev
                </button>
                <span>Page {currentPage} of {totalPages}</span>
                <button 
                    disabled={currentPage === totalPages} 
                    onClick={() => setCurrentPage(prev => prev + 1)}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default SavingsAccountReport;